export const SITE_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  siteName: 'siteName',
  siteId: 'siteId',
  certificates: 'certificates',
  siteTypes: 'siteTypes',
  terminalCount: 'terminalCount',
  materialCount: 'materialCount',
  processCount: 'processCount',
});

export const SITE_SORT_FIELDS = Object.freeze({});

export const SITE_TERMINAL_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  terminalName: 'terminalName',
  terminalId: 'terminalId',
  materialCount: 'materialCount',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  country: 'country',
  zipCode: 'zipCode',
  actions: 'actions',
});

export const SITE_MATERIAL_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  materialName: 'materialName',
  materialCode: 'materialCode',
  referenceId: 'referenceId',
  materialType: 'materialType',
  certificateType: 'certificateType',
  materialRole: 'materialRole',
  process: 'process',
  declarationSettings: 'declarationSettings',
  declarationUnit: 'declarationUnit',
  workingUnit: 'workingUnit',
  conversionFactor: 'conversionFactor',
  energyContent: 'energyContent',
  actions: 'actions',
});

export const SITE_MB_PERIOD_COLUMNS = Object.freeze({
  serialNo: 'serialNo',
  periodName: 'periodName',
  timePeriod: 'timePeriod',
  status: 'status',
  startDate: 'startDate',
  endDate: 'endDate',
});

export const SITE_MATERIAL_TAB = 'material';

// Mirrors the server's own limits — MAX_MB_PERIODS_PER_SITE / MIN_MB_PERIOD_LENGTH_DAYS.
export const MAX_MB_PERIODS = 12;
export const MIN_MB_PERIOD_LENGTH_DAYS = 3;
// ISCC: quarterly, semi-annual or monthly periods only.
export const MB_PERIOD_COUNTS = Object.freeze(['4', '6', '12']);

export const MB_PERIOD_FIELDS = Object.freeze({
  siteName: 'siteName',
  terminalIds: 'terminalIds',
  numberOfPeriods: 'numberOfPeriods',
  periodKeys: 'periodKeys',
});

export const MB_PERIOD_DETAIL_FIELDS = Object.freeze({
  name: 'name',
  startDate: 'startDate',
  endDate: 'endDate',
  status: 'status',
});

export const mbPeriodFieldName = (periodKey, field) => `periods.${periodKey}.${field}`;

export const mbPeriodKeys = (count) =>
  Array.from({ length: Number(count) || 0 }, (_, index) => String(index + 1));

export const emptyMbPeriodDetailValues = (periodKey) =>
  Object.fromEntries(
    Object.values(MB_PERIOD_DETAIL_FIELDS).map((field) => [
      mbPeriodFieldName(periodKey, field),
      '',
    ]),
  );

export const EMPTY_MB_PERIOD_FORM = Object.freeze({
  [MB_PERIOD_FIELDS.siteName]: '',
  [MB_PERIOD_FIELDS.terminalIds]: [],
  [MB_PERIOD_FIELDS.numberOfPeriods]: '',
  [MB_PERIOD_FIELDS.periodKeys]: [],
});

export const ASSIGN_MATERIALS_FIELDS = Object.freeze({
  terminalId: 'terminalId',
  materialIds: 'materialIds',
});

export const EMPTY_ASSIGN_MATERIALS_FORM = Object.freeze({
  [ASSIGN_MATERIALS_FIELDS.terminalId]: '',
  [ASSIGN_MATERIALS_FIELDS.materialIds]: [],
});

export const ENERGY_PER_KG_UNIT = 'MJ / kg';

export const SITE_MATERIAL_SEARCH_FIELDS = Object.freeze([
  SITE_MATERIAL_COLUMNS.materialName,
  SITE_MATERIAL_COLUMNS.materialCode,
  SITE_MATERIAL_COLUMNS.referenceId,
]);

export const SITE_TERMINAL_SEARCH_FIELDS = Object.freeze([
  SITE_TERMINAL_COLUMNS.terminalName,
  SITE_TERMINAL_COLUMNS.terminalId,
]);

export const SITE_SEARCH_IN = Object.freeze(['site_name', 'site_id']);

export const SITE_FIELDS = Object.freeze({
  siteName: 'siteName',
  siteDeclarationName: 'siteDeclarationName',
  siteId: 'siteId',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  country: 'country',
  zipCode: 'zipCode',
  certificateType: 'certificateType',
  siteTypes: 'siteTypes',
  certificationStatus: 'certificationStatus',
  isccCertificateNumber: 'isccCertificateNumber',
  validFrom: 'validFrom',
  validTo: 'validTo',
  terminalKeys: 'terminalKeys',
});

export const TERMINAL_FIELDS = Object.freeze({
  id: 'id',
  terminalName: 'terminalName',
  terminalId: 'terminalId',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  country: 'country',
  zipCode: 'zipCode',
});

export const MAX_TERMINALS = 3;
export const MIN_TERMINALS = 1;

export const TERMINAL_NAME_MAX_LENGTH = 80;

export const terminalFieldName = (terminalKey, field) => `terminals.${terminalKey}.${field}`;

export const nextTerminalKey = (terminalKeys) =>
  String(terminalKeys.reduce((highest, key) => Math.max(highest, Number(key) || 0), 0) + 1);

export const emptyTerminalValues = (terminalKey) =>
  Object.fromEntries(
    Object.values(TERMINAL_FIELDS).map((field) => [terminalFieldName(terminalKey, field), '']),
  );

export const FIRST_TERMINAL_KEY = '1';

export const EMPTY_SITE_FORM = Object.freeze({
  [SITE_FIELDS.siteName]: '',
  [SITE_FIELDS.siteDeclarationName]: '',
  [SITE_FIELDS.siteId]: '',
  [SITE_FIELDS.addressLine1]: '',
  [SITE_FIELDS.addressLine2]: '',
  [SITE_FIELDS.city]: '',
  [SITE_FIELDS.country]: '',
  [SITE_FIELDS.zipCode]: '',
  [SITE_FIELDS.certificateType]: '',
  [SITE_FIELDS.siteTypes]: [],
  [SITE_FIELDS.certificationStatus]: '',
  [SITE_FIELDS.isccCertificateNumber]: '',
  [SITE_FIELDS.validFrom]: '',
  [SITE_FIELDS.validTo]: '',
  [SITE_FIELDS.terminalKeys]: [FIRST_TERMINAL_KEY],
  ...emptyTerminalValues(FIRST_TERMINAL_KEY),
});
